import * as THREE from "three/webgpu"

export default class Video {
  videoID: string
  videoEl!: HTMLVideoElement
  texture!: THREE.VideoTexture

  constructor({ videoID }: { videoID: string }) {
    this.videoID = videoID

    this.videoEl = document.getElementById(this.videoID) as HTMLVideoElement

    if (!this.videoEl) {
      console.warn(`Video ${this.videoID} not found`)
      return
    }

    this.setVideoTexture()
  }

  setVideoTexture() {
    this.videoEl.play()

    this.texture = new THREE.VideoTexture(this.videoEl)
    this.texture.colorSpace = THREE.SRGBColorSpace
  }

  getSize() {
    return {
      width: this.videoEl.videoWidth,
      height: this.videoEl.videoHeight,
      ratio: this.videoEl.videoWidth / this.videoEl.videoHeight,
    }
  }

  waitForMetadata(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.videoEl) {
        reject(new Error("Video element not found"))
        return
      }

      // If metadata is already loaded (readyState >= 1)
      if (this.videoEl.readyState >= 1) {
        resolve()
        return
      }

      // Wait for loadedmetadata event
      this.videoEl.addEventListener(
        "loadedmetadata",
        () => {
          resolve()
        },
        { once: true },
      )
    })
  }
}
